import AxiosContent from '@/services/api/content/axios_content'

export default {
  searchByTerm: (params) => {
    return AxiosContent.get('search', {params})
  },
}
